(function ($, Drupal, drupalSettings) {

  var windowWidth = function(){
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth);
  }
  Drupal.behaviors.treston_contact = {

  	contactUs: {
      getSubmitButton: function(el){
        return $('input[type="submit"]',el);
      },

      simulateUser: function(el){
        var that = Drupal.behaviors.treston_contact.contactUs;
        var b = that.getSubmitButton(el);
        var url = window.location.href;
        b.hide();
        var select = $('select',el);
        var stateSelect = $('select[name="field_state_value"]', el);
        select.on('change', function(){
          b.click();
          if(select.val() == 'US') {
            $('body').addClass('country-en-us');
          }
          else {
            $('body').removeClass('country-en-us');
          }
        });
        if( url.indexOf('?field_country_value=') === -1 && select.val() != document.getElementsByTagName('html')[0].getAttribute('lang') &&
            typeof window.firstLoadedContactUs == 'undefined' ){
          var lang = document.getElementsByTagName('html')[0].getAttribute('lang').toUpperCase();
          if( lang == 'EN' ){
            lang = 'GB';
          }else if ( lang == 'SV' ){
            lang = 'SE';
          }
          else if (lang == 'EN-US') {
            lang = 'US';
            $('body').addClass('country-en-us');
          }
          window.firstLoadedContactUs = true;
          select.val( lang );
          if(lang == 'US') {
            stateSelect.val('Georgia'); // Gergia as default
          }
          b.click();
        }
        $('select option',el).get(0).remove();
      },

      /** Only used in set timeout to wait that ajaxhandlers have attached */
      waitForViewsBinding: function (el){
        var that = Drupal.behaviors.treston_contact.contactUs;
        if( typeof $._data( that.getSubmitButton(el).get(0), 'events' ) == 'undefined' ){
          setTimeout(that.waitForViewsBinding,16,el);
        }else {
          that.simulateUser(el);
        }
      },
    },


    attach: function(context, settings) {

      // contact us selector
      $('form#views-exposed-form-contact-us-offices-block',context).each(function( i, selector ){
        Drupal.behaviors.treston_contact.contactUs.waitForViewsBinding(selector);
      });

    }

  }

})(jQuery, Drupal, drupalSettings);